import React from 'react';
import PropTypes from 'prop-types';

export const Footer = ({children}) => (<footer className="form-footer">{children}</footer>);
Footer.propTypes = () => ({children: PropTypes.any.isRequired});
